export default __webpack_public_path__ + "static/media/MaduroTorpedoOpen.8a5899cb.jpg";